import ScrollReveal from 'scrollreveal';

ScrollReveal().reveal('main', {
  distance: '20px',
  duration: 1500,
});
